import { atom } from 'recoil';
import { getConfigVariable } from '../../fn/Config';
import { getExperimentVariant } from '../../../component/Experiments/utils/experimentUtils';

const AB_ENABLED = getConfigVariable('APPOINTMENT_SELECTION_AB');

const getAppointmentSelectionVersionFromQuery = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('appointmentSelectionVersion');
};

let wasAssignedByExperiment = false;

function resolveDefault() {
  const forced = getAppointmentSelectionVersionFromQuery();
  if (forced === '2' || forced === '3' || forced === '4') {
    window.appointmentSelectionVersion = forced;
    return forced;
  }
  if (!AB_ENABLED) {
    window.appointmentSelectionVersion = '2';
    return '2';
  }
  wasAssignedByExperiment = true;
  const version = getExperimentVariant('appointment-selection-v4', 0.5) ? '4' : '2';
  window.appointmentSelectionVersion = version;
  return version;
}

const resolved = resolveDefault();

export const appointmentSelectionVersion = atom({
  key: 'appointmentSelectionVersion',
  default: resolved,
});

export function isAppointmentSelectionExperiment() {
  return wasAssignedByExperiment;
}
